export default __webpack_public_path__ + "static/media/thum_intro_Goto.833f28ce.PNG";